import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { Ripple } from 'primeng/ripple';
import { Tooltip } from 'primeng/tooltip';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { LayoutService, MenuMode } from '../layout.service';
import { AuthService } from '../../core/auth/auth.service';
import { MENU, AppMenuItem } from '../menu';
import { User } from '../../core/models/user.model';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, Ripple, Tooltip, MenuItemComponent],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {
  layoutService = inject(LayoutService);
  private auth  = inject(AuthService);

  menuSections: AppMenuItem[] = MENU;
  private sub: Subscription | null = null;

  ngOnInit(): void {
    this.sub = this.auth.currentUser$.subscribe(user => {
      this.menuSections = this.filterMenu(user);
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private filterMenu(user: User | null): AppMenuItem[] {
    const modules    = user?.modules ?? ['*'];
    const userType   = user?.userType ?? null;
    const allModules = modules.includes('*');

    const filterItem = (item: AppMenuItem): boolean => {
      if (item.moduleKey && !allModules) {
        if (!modules.some(m => m.toLowerCase() === item.moduleKey!.toLowerCase())) return false;
      }
      if (item.allowedUserTypes?.length && userType) {
        if (!item.allowedUserTypes.includes(userType)) return false;
      }
      return true;
    };

    return MENU
      .map(section => ({ ...section, items: (section.items ?? []).filter(filterItem) }))
      .filter(section => (section.items ?? []).length > 0);
  }

  get isSlimMode(): boolean {
    return this.layoutService.isSlim() || this.layoutService.isSlimPlus();
  }

  get isSlimCollapsed(): boolean {
    return this.isSlimMode
      && !this.layoutService.state().sidebarActive
      && !this.layoutService.state().anchored;
  }

  get isAnchored(): boolean {
    return this.layoutService.state().anchored;
  }

  toggleAnchor(): void {
    this.layoutService.toggleAnchor();
  }

  setMode(mode: MenuMode): void {
    this.layoutService.setMenuMode(mode);
  }
}
